import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GeneralHelper } from '../helpers/general.helper';

@Injectable({
  providedIn: 'root'
})
export class PdvRepository {

  private apiUrl: string = environment.apiUrl;

  constructor(
    private httpClient: HttpClient,
    private generalHelper: GeneralHelper
  ) { }

  public loadSite(params?: any): Observable<any> {
    let query = this.generalHelper.buildQuery(params);
    return this.httpClient.get<any>(`${this.apiUrl}/PDV/load/site?${query}`);
  }

  public cupomSalesReport(eventId: string, cupom: string): Observable<any> {
    return this.httpClient.get<any>(this.apiUrl + "/report/getCuponsByEvent?eventId=" + eventId + "&ticketTags=" + cupom);
  }

  public loadPdvs() {
    return this.httpClient.get<any>(`${this.apiUrl}/PDV/list`);
  }

  public loadProducerEvents(param?: any): Observable<any> {
    let query = this.generalHelper.buildQuery(param);
    return this.httpClient.get<any>(`${this.apiUrl}/event/list2list?${query}`);
  }

  public loadProducerReportEvents(param?: any): Observable<any> {
    let query = this.generalHelper.buildQuery(param);
    return this.httpClient.get<any>(`${this.apiUrl}/event/list2report?${query}`);
  }

  public getCustomerTickets(eventId: string) {
    let headers = new HttpHeaders();
    headers = headers.set('nono-captcha', 'nono-captcha');
    return this.httpClient.get<any>(`${this.apiUrl}/customer/eventTicketsTotal/${eventId}`, { headers: headers });
  }

  public loadTermsOfUse(): Observable<any> {
    return this.httpClient.get<any>(`${this.apiUrl}/PDV/load/termsOfUse`);
  }

  public loadAboutUs(): Observable<any> {
    return this.httpClient.get<any>(`${this.apiUrl}/PDV/load/aboutus`);
  }

}
